import type { CSSProperties, ReactNode } from 'react';
import './kit.css';

export type AppScreenSize = 'sm' | 'md' | 'lg';

export interface AppScreenProps {
  size?: AppScreenSize;
  children: ReactNode;
}

const LOGICAL_WIDTH = 375;
const LOGICAL_HEIGHT = 812;

// Must match PhoneFrame's inner screen width (phone width - 2 * bezel padding
// - 2 * screen inset) so screens and dim overlays reach the device edges.
const INNER_WIDTH: Record<AppScreenSize, number> = {
  sm: 160,
  md: 218,
  lg: 280,
};

export function AppScreen({ size = 'md', children }: AppScreenProps) {
  const scale = INNER_WIDTH[size] / LOGICAL_WIDTH;
  const viewportWidth = LOGICAL_WIDTH * scale;
  const viewportHeight = LOGICAL_HEIGHT * scale;

  const viewportStyle: CSSProperties = {
    width: `${viewportWidth}px`,
    height: `${viewportHeight}px`,
  };
  const screenStyle: CSSProperties = {
    transform: `scale(${scale})`,
  };

  return (
    <div className='mk-appscreen' style={viewportStyle}>
      <div className='mk-screen' style={screenStyle}>
        {children}
      </div>
    </div>
  );
}
